import { setCookie } from '@/utils'
import { ACCESS_TOKEN } from '@/store/mutation-types'
export const setToken = res => {
  setCookie(ACCESS_TOKEN, res.access_token, 7, '.babybus.com')
  if (window.location.hostname === 'localhost') {
    setCookie(ACCESS_TOKEN, res.access_token, 7)
  }
}
